const navbar = {
  height: 54,
};

export { navbar };
